export default __webpack_public_path__ + "img/2-1-4d54b296.png";